import { type UseQueryResult, useQuery } from 'react-query';
import {
  InstanceSwitchService,
  Wealthlane_AppServices_Sandbox_TenantSwitchableResponseDto,
} from '../../services/wealthlane-identity-services';

const useGetSwitchableByRole = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  props: {
    companyId: string;
    roleId: string;
    onSuccess?: (data: Array<{ label: string; value: string }> | undefined) => void;
  }
): UseQueryResult<Array<{ label: string; value: string }> | undefined, unknown> => {
  const { companyId, roleId, onSuccess } = props;
  const switchableByRole = useQuery(
    ['getSwitchableByRole', companyId, roleId],
    async () => {
      return await handleRequest(
        InstanceSwitchService.getApiIdentityApiInstanceSwitchableByRole(companyId, roleId)
      );
    },
    {
      enabled: Boolean(companyId) || Boolean(roleId),
      cacheTime: 0,
      select: (data) => {
        return data?.map((item) => ({
          label: item?.name,
          value: item?.id,
        }));
      },
      onSuccess: (data) => {
        if (onSuccess) {
          onSuccess(data);
        }
      },
    }
  );

  return switchableByRole;
};

export default useGetSwitchableByRole;
